import { render, staticRenderFns } from "./DashboardDeviceUnconfigured.vue?vue&type=template&id=0a471951&scoped=true&"
import script from "./DashboardDeviceUnconfigured.vue?vue&type=script&lang=js&"
export * from "./DashboardDeviceUnconfigured.vue?vue&type=script&lang=js&"
import style0 from "./DashboardDeviceUnconfigured.vue?vue&type=style&index=0&id=0a471951&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a471951",
  null
  
)

export default component.exports